export const PACKAGES = [
  {
    id: 0,
    title: 'Option A',
    price: '$99',
    value: 'option_a',
    descriptionOne: 'Premier Business Placement on Destinflorida.com',
    descriptionTwo: 'Included on highly ranked ‘Things To Do’ Pages',
    descriptionThree: 'Included in Facebook Retargeting Ads',
    descriptionFour: 'Full Account Support',
  },
  {
    id: 1,
    title: 'Option B',
    price: '$297',
    value: 'option_b',
    descriptionOne: 'Premier Business Placement on Destinflorida.com',
    descriptionTwo: 'Included on highly ranked ‘Things To Do’ Pages',
    descriptionThree: 'Phone consultation with Five Channels Marketing',
    descriptionFour: 'Custom Ad Campaign Setup',
    descriptionFive: 'Custom Audience Targeting',
    descriptionSix: 'Creative Assistance',
  },
  {
    id: 2,
    title: 'Option C',
    price: '$997',
    value: 'option_c',
    descriptionOne: 'Premier Business Placement on Destinflorida.com',
    descriptionTwo: 'Included on highly ranked ‘Things To Do’ Pages',
    descriptionThree: 'Phone consultation with Five Channels Marketing',
    descriptionFour: 'Custom Ad Campaign Setup',
    descriptionFive: 'Custom Audience Targeting',
    descriptionSix: 'Custom Creatives, Photography & Drone Footage',
  },
];
